import { FC, useEffect, useState } from 'react'

import { notifyMe, subscribeToWatchlist } from 'features/firebase/watchlist'
import { useAuthStore } from 'features/user/auth-store'

import { GreenButton } from 'shared/components'
import { Card, CardContent, CardHeader, CardTitle } from 'shared/components/ui/card'

export const BuyBoardGame: FC = () => {
  const [watchlist, setWatchlist] = useState<string[]>([])
  const { user } = useAuthStore()
  const isOnWatchlist = user?.email && watchlist.includes(user.email)

  useEffect(() => {
    subscribeToWatchlist(res => setWatchlist(res ?? []))
  }, [])

  const cardTitle = isOnWatchlist ? 'Thank You!' : 'Exciting News!'
  const cardContent = isOnWatchlist
    ? "Your email has been saved. We'll be in touch with updates and release information soon."
    : `We're thrilled to announce that we're working on a board game version of our popular online game. If
          you're interested in being one of the first to know when it's available, ${!user ? 'log in and ' : ''}
          click notify button below.`

  return (
    <Card className="mx-auto my-10 flex w-11/12 flex-col items-center justify-center gap-2 p-2 sm:gap-6 lg:w-[800px]">
      <CardHeader>
        <CardTitle>{cardTitle}</CardTitle>
      </CardHeader>
      <CardContent className="space-y-5">
        <p>{cardContent}</p>
        {!isOnWatchlist && (
          <GreenButton
            text="Notify Me"
            disabled={!user || !user.email}
            onClick={() => user?.email && notifyMe(user.email)}
            className="w-full"
          />
        )}
      </CardContent>
    </Card>
  )
}
